"use client";

import { Swiper } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { SectionsLogoCarousel } from "../../../types";
import { CarouselButton } from "../../common/carousel-button";
import { logoCarouselSwiperVariant } from "./logo-carousel-swiper.variants";
import NextImage from "next/image";
import { SwiperSlide } from "swiper/react";

export interface LogoCarouselSwiperProps {
  logos: SectionsLogoCarousel["logos"] | [];
}

function LogoCarouselSwiper({ logos }: LogoCarouselSwiperProps) {
  const swiperId = "logos-carousel";
  const styles = logoCarouselSwiperVariant();

  return (
    <div className={styles.wrapper()}>
      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          720: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 32,
          },
        }}
        modules={[Navigation]}
        navigation={{
          prevEl: `.prev-carousel-${swiperId}`,
          nextEl: `.next-carousel-${swiperId}`,
        }}
        simulateTouch={false}
        slidesPerView={5}
        spaceBetween={0}
        loop={true}
        className={styles.swiper()}
      >
        {!!logos &&
          logos.map((logo) => (
            <SwiperSlide key={`logo-${logo.id}`} className={styles.slide()}>
              <NextImage
                src={logo.url}
                alt={logo.alternativeText || ""}
                className={styles.image()}
                height={logo.height}
                width={logo.width}
              />
            </SwiperSlide>
          ))}
      </Swiper>
      <nav className={styles.nav()} id={swiperId}>
        <CarouselButton
          className={`prev-carousel-${swiperId} pointer-events-auto border-none bg-transparent`}
          startIcon="arrow-left"
        />
        <CarouselButton
          className={`next-carousel-${swiperId} pointer-events-auto border-none bg-transparent`}
          startIcon="arrow-right"
        />
      </nav>
    </div>
  );
}

export default LogoCarouselSwiper;
